import * as React from 'react';
import ILPVSokProps from './IEksamensoppgaverProps';
import ILPVSokState from './IEksamensoppgaverState';
import Pagination from '../SharedComponents/Pagination/Pagination';
import ResultPane from './ResultPane/ResultPane';
import NoResultPane from '../SharedComponents/NoResultPane/NoResultPane';
import Filter from '../SharedComponents/Filter/Filter';
import SearchBox from '../SharedComponents/SearchBox/SearchBox';
//import Navigation from '../SharedComponents/Navigation/Navigation';
import FiltersSelected from '../SharedComponents/FiltersSelected/FiltersSelected';
import SearchNavigationTabs from '../SharedComponents/SearchNavigationTabs/SearchNavigationTabs';
import './Eksamensoppgaver.scss';
import { addNonActiveFilters, getFilterNames } from '../../utils';
import { getResults } from './getResults';
import { hasUsableSpellingSuggestion } from '../../utils/resultHelpers';
import IRefiners from '../../Models/IRefiners';
import IResponse from '../../Models/IResponse';
import { DisplayFormat } from '../../Models/DisplayFormat';
import { SearchPageLayout } from '../../Models/SearchLayout';
import { Resultnumber } from '../SharedComponents/Resultnumber';
import { toggleToTopComponent } from '../SharedComponents/MoveToTop/MoveToTop';
//import { InfoBox } from '../SharedComponents/InfoBox/InfoBox';
import { SuggestionBox } from '../SharedComponents/SuggestionBox';
import { InformationMessageBox } from '../SharedComponents/InformationMessageBox';
import { getUrlParameter, setUrlParameter, removeAllFilterParams, getFilterParametersFromUrl, removeHashFromUrl } from '../../utils/urlParamHelper';
import { ensureSelectedFilterValues, getNumberOfActiveFilters, emptyFilterCheckboxes, getFilterNamesWithCheckedItems, updateFilterCounts } from '../../utils/refinerHelpers';
import { getInfoMsg } from '../../utils/searchHelpers';
import { getCurrentDisplayFormat } from '../../utils/generalHelpers';
//import { Log } from '../../utils/logging';
import { IEksamensoppgaverResult } from '../../Models/IResult';
//import { SearchSite } from '../../utils/setupHeaderAndFooter';
import SortBySuggestion from "../SharedComponents/Suggestion/SortBySuggestion";
import { Heading, Button, ListUnordered, ListItem } from '@udir-design/react/beta';
import { ChevronDownIcon, ChevronUpIcon } from '@udir-design/icons';
import '../../udirsok-searchbox-redesign.scss'

export default class Eksamensoppgaver extends React.Component<ILPVSokProps, ILPVSokState> {
    private resultPerPage = 10;
    private refinementFilters = ['ExTestType', 'ExCatalogTypeName', 'ExPeriodName'];
    private refinementFiltersShowAllValuesUrlParamName = 'filtervalues';
    private queryParameter = "query";

    public constructor(props: ILPVSokProps) {
        super(props);
        // Removing hash (#) from URL if exists
        if(window.location.hash && window.location.hash !== ""){
            removeHashFromUrl(window.location.href);
        }
        //Set up initial querydata from parameters
        let queryParameter = getUrlParameter(this.queryParameter);
        if(getUrlParameter("k") !== undefined){
            this.queryParameter = "k"
            queryParameter = getUrlParameter(this.queryParameter);
        }
        const normalizedInitialQuery = queryParameter && queryParameter.trim() === '*' ? '' : queryParameter;
        const initialPageNumber = getUrlParameter('page');
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);
        this.state = {
            currentPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : 1,
            initialQuery: normalizedInitialQuery,
            displayFormat: getCurrentDisplayFormat(),
            initialPageNumber: initialPageNumber !== undefined ? Number(initialPageNumber) : undefined,
            initialFilters: filterParameters ? filterParameters : undefined,
            showSearchTips: false
        };
    }

    public componentDidMount() {
        window.addEventListener('resize', _ => this._onWindowResize());
        window.onpopstate = () => this.onStatePopped();
        window.addEventListener('pageshow', (event: PageTransitionEvent) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
        this.setupAndRunInitialQuery();
        getInfoMsg().then(result => {
            if(result){
                if(result.eksamen){
                    this.setState({ informationMessage: result.eksamen.title });
                }
                for (var i = 0; i < result.length; i++) {
                    if(result[i].hasOwnProperty("eksamen")){
                        this.setState({ informationMessage: result[i].eksamen.title });
                        break;
                    }
                }
            }
        });
    }

    public componentDidUpdate() {
        toggleToTopComponent(this.state.results && this.state.results.items.length > 0);
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', _ => this._onWindowResize());
        this._onWindowResize();
    }

    public render() {
        const numberOfResults = this.findNumberOfResults();
        const numberOfPages = this.findNumberOfPages();
        const numberOfActiveFilters = getNumberOfActiveFilters(this.state.filter, this.refinementFilters);
        const isDesktop = this.state.displayFormat === DisplayFormat.Desktop;
        const searchLayout = SearchPageLayout.FilterLeftResultsRight;
        const searchboxClass = (isDesktop && searchLayout===0) ? "searchBoxBanner filterLeftAligned" : "searchBoxBanner";
        const searchboxClassWithToggle = `${searchboxClass} ${this.state.showSearchTips ? 'tips-open' : 'tips-closed'}`;
        const resultinformationClass = isDesktop ? "searchVerticals" : "searchVerticals";
        const filterClass = "filters";
        const searchresultsClass = "uds-results";
        const shouldDisplayFilters = (this.state.results && this.state.results.items && this.state.results.items.length > 0) || 
            (this.state.filter && getNumberOfActiveFilters(this.state.filter, this.refinementFilters) > 0);
        const showAutocomplete = true;
        return (
            <div id="main-content" className="searchContainer">
                <div className='searchBoxBannerOuter'>
                    <div className={`${searchboxClassWithToggle}`}>
                        <div className="searchBoxBannerContent">
                            <div className="searchBoxContent">
                                <div className="leftBarSearchBox">
                            <div className="searchHeader">
                                <Heading className='searchText' level={1} data-size={isDesktop ? 'lg' : 'md'}>
                                    Søk i eksamensoppgaver
                                </Heading>
                            </div>
                            <SearchBox
                                initialQuery={this.state.initialQuery ? this.state.initialQuery : ''}
                                onSearch={(query, searchAsYouType) => this.onSearch(query, searchAsYouType)}
                                newQuery={this.state.newStateQuery}
                                placeholderText="Søk etter eksamensoppgaver, veiledninger, eksempeloppgaver"
                                autocomplete={showAutocomplete} 
                                searchVertical="Eksamen"/>
                            {/*<Navigation searchQuery={this.state.searchboxQuery} />*/}
                                </div>
                                <div className="rightBarSearchBox">
                                    {/* 
                                    <Button
                                        data-size="md"
                                        variant='tertiary'
                                        color='neutral'
                                        className="SearchTipsButton"
                                        onClick={() => this.setState({ showSearchTips: !this.state.showSearchTips })}
                                        aria-expanded={!!this.state.showSearchTips}
                                        aria-controls="SearchTipsContent"
                                    >
                                        Søketips
                                        {this.state.showSearchTips ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </Button>
                                    {this.state.showSearchTips && (
                                        <div className="SearchTipsContent" id="SearchTipsContent">
                                            <div className='SearchTipsContentText'>
                                                <ListUnordered>
                                                    <ListItem>
                                                        Søk på eksamensoppgaver, forberedelsesdeler, eksamensveiledninger, eksempeloppgaver, vurderte eksamenssvar, eksamensrapporter, vurderingsskjema og sensorveiledninger.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan angi flere ord innenfor anførselsestegn («…») for å søke etter disse ordene i den bestemte, angitte rekkefølgen. For eksempel søk på «norsk skriftlig» for å finne søketreff med ordene i nøyaktig den rekkefølgen.
                                                    </ListItem>
                                                    <ListItem>
                                                        Man kan bruke - for å ekskludere ord. For eksempel søke på: <em>rapporter -årsrapporter</em> for å finne alle treff med rapporter som ikke har med ordet årsrapporter
                                                    </ListItem>
                                                </ListUnordered>
                                            </div>
                                        </div>
                                    )}
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={`${resultinformationClass}`}>
                    <SearchNavigationTabs
                        currentTab="eksamen"
                        searchQuery={(() => {
                            const tabQuery = this.state.searchboxQuery || this.state.query;
                            return tabQuery === '*' ? '' : tabQuery;
                        })()}
                    />
                    {!isDesktop && shouldDisplayFilters && this.state.filter && (
                        <Filter
                            getFilterDisplayName={filterName => this.getFilterDisplayName(filterName)}
                            refiners={this.state.filter}
                            onFilterSelected={this.onFilterChanged.bind(this)}
                            onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                            displayFormat={this.state.displayFormat}
                            initialOpenFilterNames={['ExCatalogTypeName', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                        />
                    )}
                    {!isDesktop && this.state.filter && numberOfActiveFilters > 0 && <FiltersSelected filters={this.state.filter} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} />}
                </div>
                <div className="resultContainer">
                    
                    <div className='filters-and-results'>
                        {isDesktop && (
                            <div className={`${filterClass}`}>

                                {shouldDisplayFilters && this.state.filter && (
                                    <Filter
                                        getFilterDisplayName={filterName => this.getFilterDisplayName(filterName)}
                                        refiners={this.state.filter}
                                        onFilterSelected={this.onFilterChanged.bind(this)}
                                        onAllFilterClicked={this.onAllFilterClicked.bind(this)}
                                        displayFormat={this.state.displayFormat}
                                        initialOpenFilterNames={['ExCatalogTypeName', ...getFilterNamesWithCheckedItems(this.state.filter)]}
                                        filterChips={numberOfActiveFilters > 0 ? <FiltersSelected filters={this.state.filter!} isDesktop={isDesktop} emptyFilters={() => this.emptyFilters()} onRemoveFilter={this.onRemoveFilter} /> : undefined}
                                    />
                                )}
                            </div>
                        )}
                        <div className={`${searchresultsClass}`}>
                            
                            <InformationMessageBox
                                isDesktop={isDesktop}
                                currentPage="Eksamensoppgaver"
                                informationMessage={this.state.informationMessage}
                            />
                            <SuggestionBox
                                query = {this.state.query}
                                searchboxQuery = {this.state.searchboxQuery}
                                erronousQuery = {this.state.erronousQuery}
                                querySuggestion = {this.state.querySuggestion}
                                emptyFilters = {() => this.emptyFilters()}
                                initialFilters = {this.state.initialFilters}
                                searchWithoutFiltersHasResults = {this.state.searchWithoutFiltersHasResults}
                                isSearchingWithDeactivatedFilters = {this.state.isSearchingWithDeactivatedFilters}
                                results = {this.state.results}
                            />
                            {this.state.results && this.state.results.items.length === 0 && this.state.query && (() => {
                                let currentFilters = getFilterParametersFromUrl(this.refinementFilters);
                                return <NoResultPane onSearchClearFilters={(query) => this.onSearchClearFilters(query)} searchQuery={this.state.query} filters={getFilterNames(currentFilters ? currentFilters : [])} />
                            })()}
                            {numberOfResults > 0 && (
                            <div className="numresults-sortby">
                                <Resultnumber
                                        currentPageNumber={this.state.currentPageNumber}
                                        isDesktop={isDesktop}
                                        numberOfResults={numberOfResults}
                                        resultPerPage={this.resultPerPage}
                                        searchQuery={this.state.query}
                                />
                                {/*numberOfResults > 0 && (
                                <div className="results-sortby-suggestion">
                                    <SortBySuggestion
                                        currentTab="eksamen"
                                        searchQuery={this.state.query}
                                        onSortChange={this.onSortChanged}
                                    />
                                </div>
                            )*/}
                            </div>
                            )}
                            
                            
                            {this.state.results && this.state.results.items.length > 0 && <ResultPane results={this.state.results.items as IEksamensoppgaverResult[]} />}
                            {numberOfPages > 1 && (
                                <Pagination
                                    currentPage={this.state.currentPageNumber}
                                    numberOfPages={numberOfPages}
                                    onPageChanged={newPageNumber => this.onPageChanged(newPageNumber)}
                                    searchQuery={this.state.searchboxQuery}
                                />
                            )}
                            {/*<MoveToTop />*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderResultPane() {
        if (!this.state.results) return null;
        if (this.state.results.items.length === 0) {
            if (!this.state.query) return null;
            let currentFilters = getFilterParametersFromUrl(this.refinementFilters);
            return (
                <NoResultPane
                    onSearchClearFilters={query => this.onSearchClearFilters(query)}
                    searchQuery={this.state.query}
                    filters={getFilterNames(currentFilters ? currentFilters : [])}
                />
            );
        }
        return <ResultPane results={this.state.results.items as IEksamensoppgaverResult[]} />;
    }

    private getFilterDisplayName(filterName: string) {
        switch (filterName) {
            case 'ExTestType':
                return 'Trinn';
            case 'ExCatalogTypeName':
                return 'Type innhold';
            case 'ExPeriodName':
                return 'År';
            case 'ExKL':
                return 'Kunnskapsløftet';
            default:
                return filterName;
        }
    }

    private translatePeriodNameForDisplay(value: string): string {
        try {
            const parts = value.split('-');
            if (parts.length === 2) {
                let newValue = parts[1] + ' ' + parts[0];
                newValue = newValue.replace('1 ', 'Vår ');
                newValue = newValue.replace('2 ', 'Høst ');
                return newValue;
            }
            return value;
        } catch {
            return value;
        }
    }

    private async setupAndRunInitialQuery() {
        let pageNumber = this.state.initialPageNumber ? this.state.initialPageNumber : 1;
        let initialFilters: any[] | undefined = undefined;
        let initialQuery: string = this.state.initialQuery ? this.state.initialQuery : '*';
        if (initialQuery !== '*') {
            setUrlParameter(document.location.href, this.queryParameter, initialQuery, true); //We do not set window.history on first load.
        }
        if (this.state.initialFilters && this.state.initialFilters.length > 0) {
            initialFilters = getFilterParametersFromUrl(this.refinementFilters);
        }
        this.setState({
            searchboxQuery: SearchBox.getSearchBoxQuery(),
            newStateQuery: undefined,
            currentPageNumber: pageNumber
        });

        // Checking if search should expand with all available filter values (used for predefined searches)
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if (filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all") {
            const allResults = await getResults(initialQuery, pageNumber, initialFilters);
            if (allResults && allResults.totalResults > 0) {
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                const remappedFilters = await this.buildFiltersDisjunctive(allResults, urlFilters, initialQuery, pageNumber);
                this.setState({
                    filter: remappedFilters,
                    results: allResults,
                    query: initialQuery,
                    isSearchingWithDeactivatedFilters: false,
                    searchWithoutFiltersHasResults: false,
                    querySuggestion: undefined
                });
            } else {
                // No results with filters — try without
                const resultsNoFilter = await getResults(initialQuery, pageNumber, addNonActiveFilters([]));
                if (resultsNoFilter && resultsNoFilter.totalResults > 0) {
                    removeAllFilterParams(window.location.href, this.refinementFilters);
                    this.setState({
                        filter: resultsNoFilter.refiners,
                        results: resultsNoFilter,
                        query: initialQuery,
                        isSearchingWithDeactivatedFilters: false,
                        searchWithoutFiltersHasResults: true,
                        querySuggestion: undefined,
                        initialFilters: undefined
                    });
                } else if (hasUsableSpellingSuggestion(allResults, initialQuery)
                        || hasUsableSpellingSuggestion(resultsNoFilter, initialQuery)) {
                    // Denne grenen går utenom runQuery, der det automatiske omsøket på
                    // stavforslag bor. Uten dette fikk brukeren bare 0-treff-meldingen
                    // og måtte trykke Søk selv (UDIRSOK-740).
                    await this.runQuery(initialQuery, false, pageNumber, initialFilters, true);
                    return;
                } else {
                    // No results at all — set state so the 0 results message is shown
                    this.setState({
                        results: allResults,
                        query: initialQuery,
                        searchWithoutFiltersHasResults: false,
                        querySuggestion: undefined
                    });
                }
            }
        } else {
            await this.runQuery(initialQuery, false, pageNumber, initialFilters, true);
        }
    }

    private onSearch(query: string, searchAsYouType: boolean) {
        let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
        let searchboxQuery = SearchBox.getSearchBoxQuery();

        // Remove filtervalues=all from URL when user searches
        if (getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all") {
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }

        this.setState({
            query: query,
            searchboxQuery: searchboxQuery,
            currentPageNumber: 1
        });
        
        // When searching with active filters, preserve all filter options
        const hasFilters = urlFilters && urlFilters.length > 0;
        
        if (hasFilters) {
            this.runQuery(query, false, 1, urlFilters, false, true); // preserveFilters = true
        } else {
            this.runQuery(query, false, 1);
        }

        //Only update when user have initiated a search from a action, not type as you search
        if (searchAsYouType === true) {
            setUrlParameter(window.location.href, this.queryParameter, query, true);
        } else {
            setUrlParameter(window.location.href, this.queryParameter, query);
        }
    }

    private onSearchClearFilters(query: string) {
        //Clear all the url-params
        this.refinementFilters.forEach(refinementFilter => {
            setUrlParameter(window.location.href, refinementFilter, '');
        });
        this.onSearch(query, false);
    }

    private onPageChanged(newPageNumber: number) {
        let filter = this.state.filter ? this.state.filter : undefined;
        if (this.state.query) {
            this.runQuery(this.state.query, false, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            //Scroll to top
            window.scrollTo(0, 0);
        }else if(this.state.query === "" && this.state.results && this.state.results.totalResults>10){
            this.runQuery("*", false, newPageNumber, filter);
            setUrlParameter(window.location.href, 'page', newPageNumber);
            this.setState({
                currentPageNumber: newPageNumber
            });
            //Scroll to top
            window.scrollTo(0, 0);
        }
    }

    private remapFilters(fetchedRefiners: IRefiners[], initFilter: any[] | undefined, selectedFilter: string) {
        if (initFilter && initFilter.length > 0) {
            this.refinementFilters.forEach(filterName => {
                let currentInitFilter = initFilter.filter(val => val.Name === filterName)[0];

                if (currentInitFilter && fetchedRefiners) {
                    let currentFetchedFilter = fetchedRefiners.filter(val => val.Name === filterName)[0];
                    if (currentFetchedFilter) {
                        currentFetchedFilter.Entries.forEach(refiner => {
                            const matched = currentInitFilter.Entries.some(val => 
                                val.RefinementToken === refiner.RefinementToken ||
                                val.RefinementName === refiner.RefinementName ||
                                val.RefinementValue === refiner.RefinementValue
                            );
                            refiner.checked = matched;
                        });
                    }
                }
            });
        }
        return fetchedRefiners;
    }

    /**
     * Update refiner counts with disjunctive-like faceting.
     * For refiners WITHOUT checked entries: use counts from filteredResults (correct cross-refiner AND logic).
     * For refiners WITH checked entries: make a separate API call excluding that refiner's filter,
     * so we get accurate counts for all values in that refiner (OR within same group).
     * Also applies visibility logic (hidden, fakeChecked) and parent sum recalculation.
     */
    private async buildFiltersDisjunctive(
        filteredResults: IResponse,
        filterParams: any[],
        queryString: string,
        pageNumber: number
    ): Promise<IRefiners[]> {
        if (!filteredResults.refiners) {
            filteredResults.refiners = [];
        }

        // Determine which refiner names have checked entries
        const checkedRefinerNames = new Set<string>(
            filterParams ? filterParams.map(p => p.Name) : []
        );

        // Deep copy refiners from filtered results as starting point
        let filters: IRefiners[] = JSON.parse(JSON.stringify(filteredResults.refiners));

        // Set checked property from filterParams
        if (filterParams && filterParams.length > 0) {
            this.refinementFilters.forEach(filterName => {
                const urlFilter = filterParams.find(p => p.Name === filterName);
                const refiner = filters.find(r => r.Name === filterName);
                if (refiner) {
                    refiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                }
            });
        }

        // For each refiner with checked entries: make disjunctive API call and replace entries
        for (const refinerName of Array.from(checkedRefinerNames)) {
            // Build filters with all refiners EXCEPT this one checked
            const filtersExcludingThisRefiner = filters.map(r => ({
                ...r,
                Entries: r.Entries.map(e => ({
                    ...e,
                    checked: r.Name === refinerName ? false : e.checked
                }))
            }));

            const disjunctiveResults = await getResults(queryString, pageNumber, filtersExcludingThisRefiner);

            if (disjunctiveResults.refiners) {
                const disjunctiveRefiner = disjunctiveResults.refiners.find(r => r.Name === refinerName);
                if (disjunctiveRefiner) {
                    // Set checked on the disjunctive entries from URL params
                    const urlFilter = filterParams.find(p => p.Name === refinerName);
                    disjunctiveRefiner.Entries.forEach(entry => {
                        entry.checked = urlFilter
                            ? urlFilter.Entries.some(e => e.RefinementToken === entry.RefinementToken)
                            : false;
                    });
                    // Replace the refiner in the filter list
                    const idx = filters.findIndex(r => r.Name === refinerName);
                    if (idx !== -1) {
                        filters[idx] = disjunctiveRefiner;
                    } else {
                        filters.push(disjunctiveRefiner);
                    }

                    // Add missing checked entries that the API didn't return (0 results for that value)
                    if (urlFilter) {
                        urlFilter.Entries.forEach(urlEntry => {
                            const exists = disjunctiveRefiner.Entries.some(e =>
                                e.RefinementValue === urlEntry.RefinementValue ||
                                e.RefinementToken === urlEntry.RefinementToken
                            );
                            if (!exists) {
                                disjunctiveRefiner.Entries.push({
                                    RefinementName: refinerName === 'ExPeriodName'
                                        ? this.translatePeriodNameForDisplay(urlEntry.RefinementName)
                                        : urlEntry.RefinementName,
                                    RefinementValue: urlEntry.RefinementValue,
                                    RefinementToken: urlEntry.RefinementToken,
                                    RefinementCount: '0',
                                    checked: true,
                                    level: 0,
                                    hidden: false
                                });
                            }
                        });
                    }
                }
            }
        }

        // Apply parent/child visibility logic
        filters.forEach(refiner => {
            // Ensure all level 0 entries (parents) and entries without parent are visible
            refiner.Entries.forEach(entry => {
                if (entry.level === 0 || !entry.parent) {
                    entry.hidden = false;
                }
            });

            // Set fakeChecked on parents and unhide children when entries are checked
            const checkedEntries = refiner.Entries.filter(entry => entry.checked === true);
            if (checkedEntries.length > 0) {
                refiner.Entries.forEach(entry => {
                    const isParent = checkedEntries.some(checkedEntry =>
                        entry.RefinementName === checkedEntry.parent && checkedEntry.parent !== undefined
                    );
                    const hasSameParent = checkedEntries.some(checkedEntry =>
                        checkedEntry.parent === entry.parent
                    );
                    if (isParent) {
                        entry.fakeChecked = true;
                    }
                    if (hasSameParent && entry.parent !== undefined) {
                        entry.hidden = false;
                    }
                });
            }

            // Unhide children when parent is checked or fakeChecked
            refiner.Entries.forEach(entry => {
                if ((entry.checked || entry.fakeChecked) && entry.level === 0) {
                    refiner.Entries.forEach(child => {
                        if (child.parent === entry.RefinementName) {
                            child.hidden = false;
                        }
                    });
                }
            });
        });

        // Recalculate checked/fakeChecked parent counts as sum of children's counts
        filters.forEach(refiner => {
            refiner.Entries.forEach(entry => {
                if (entry.level === 0 && (entry.checked || entry.fakeChecked)) {
                    const children = refiner.Entries.filter(child => child.parent === entry.RefinementName && child.level === 1);
                    if (children.length > 0) {
                        const sum = children.reduce((acc, child) => acc + parseInt(child.RefinementCount || "0", 10), 0);
                        entry.RefinementCount = String(sum);
                    }
                }
            });
        });

        return filters;
    }

    private async runQuery(query: string, isRerun: boolean, pageNumber?: number, filter?: IRefiners[], isInitialQuery?: boolean, preserveFilters?: boolean) {
        if (!filter && !preserveFilters) {
            filter = this.state.filter;
        }
        let _pageNumber = pageNumber !== undefined ? pageNumber : 1;
        let results = await getResults(query, _pageNumber, filter);
        let resultsNoFilter;

        // Getting all results without filters if filtervalues=all found in url
        let allResultsNoFilters;
        let useAllResultsNoFilters = false;
        const filterValuesUrlParam = getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName);
        if (filterValuesUrlParam && filterValuesUrlParam.toLowerCase() === "all") {
            allResultsNoFilters = await getResults(query, _pageNumber, addNonActiveFilters([]));
            useAllResultsNoFilters = true;
        }

        if (results.items.length === 0) {
            //Run query without any filters
            resultsNoFilter = await getResults(query, _pageNumber, addNonActiveFilters([]));
        }

        if (results.spellingSuggestion !== undefined && results.spellingSuggestion !== query && results.spellingSuggestion.length > 0 && results.items.length === 0) {
            //Run again with querysuggestion

            this.setState({
                querySuggestion: results.spellingSuggestion,
                erronousQuery: query
            });
            this.runQuery(results.spellingSuggestion, true, pageNumber, filter, isInitialQuery, preserveFilters);
            return;
        } else if (resultsNoFilter && (resultsNoFilter.totalResults > 0 || getFilterParametersFromUrl(this.refinementFilters).length > 0)) {
            // Filters gave 0 results but query without filters has results,
            // or both give 0 results but user has active filters that need to stay visible.
            // In Eksamen all filters are user-selected, so show 0 results
            // with filters preserved so the user can adjust them.
            const urlFilterParams = getFilterParametersFromUrl(this.refinementFilters);
            const remapped = this.remapFilters(resultsNoFilter.refiners || [], urlFilterParams, '');

            // Add missing URL-selected filter entries that aren't in the refiners (count=0)
            // so the user can see and remove them
            if (urlFilterParams && urlFilterParams.length > 0) {
                urlFilterParams.forEach(urlFilter => {
                    let refiner = remapped.find(r => r.Name === urlFilter.Name);
                    if (!refiner) {
                        // Entire refiner group is missing — add it
                        refiner = { Name: urlFilter.Name, Entries: [] };
                        remapped.push(refiner);
                    }
                    urlFilter.Entries.forEach(urlEntry => {
                        const exists = refiner!.Entries.some(e =>
                            e.RefinementValue === urlEntry.RefinementValue ||
                            e.RefinementName === urlEntry.RefinementName ||
                            e.RefinementToken === urlEntry.RefinementToken
                        );
                        if (!exists) {
                            refiner!.Entries.push({
                                RefinementName: urlFilter.Name === 'ExPeriodName'
                                    ? this.translatePeriodNameForDisplay(urlEntry.RefinementName)
                                    : urlEntry.RefinementName,
                                RefinementValue: urlEntry.RefinementValue,
                                RefinementToken: urlEntry.RefinementToken,
                                RefinementCount: "0",
                                checked: true,
                                level: 0,
                                hidden: false
                            });
                        }
                    });
                });
            }

            // Apply parent/child visibility logic so checked children are visible
            remapped.forEach(refiner => {
                refiner.Entries.forEach(entry => {
                    if (entry.level === 0 || !entry.parent) {
                        entry.hidden = false;
                    }
                });
                const checkedEntries = refiner.Entries.filter(entry => entry.checked === true);
                if (checkedEntries.length > 0) {
                    refiner.Entries.forEach(entry => {
                        const isParent = checkedEntries.some(ce =>
                            entry.RefinementName === ce.parent && ce.parent !== undefined
                        );
                        const hasSameParent = checkedEntries.some(ce =>
                            ce.parent === entry.parent
                        );
                        if (isParent) {
                            entry.fakeChecked = true;
                            entry.checked = false;
                        }
                        if (hasSameParent && entry.parent !== undefined) {
                            entry.hidden = false;
                        }
                    });
                }
                refiner.Entries.forEach(entry => {
                    if ((entry.checked || entry.fakeChecked) && entry.level === 0) {
                        refiner.Entries.forEach(child => {
                            if (child.parent === entry.RefinementName) {
                                child.hidden = false;
                            }
                        });
                    }
                });
            });

            this.setState({
                filter: remapped,
                results: results,
                query: query,
                isSearchingWithDeactivatedFilters: false,
                searchWithoutFiltersHasResults: false,
                querySuggestion: undefined
            });
        } else {
            //Found results, setting all the proper variables.

            let setStateObject: any = {
                results: results,
                searchWithoutFiltersHasResults: false
            };

            if (preserveFilters) {
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, query, _pageNumber);
            } else if (isInitialQuery) {
                setStateObject['filter'] = await this.buildFiltersDisjunctive(results, this.state.initialFilters || [], query, _pageNumber);
            } else if (useAllResultsNoFilters) {
                setStateObject['filter'] = this.remapFilters(allResultsNoFilters.refiners, getFilterParametersFromUrl(this.refinementFilters), "");
            } else {
                // Check if there are any checked filters in the current state
                const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
                const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;

                if (hasCheckedFilters) {
                    setStateObject['filter'] = await this.buildFiltersDisjunctive(results, currentFilterParams, query, _pageNumber);
                } else {
                    setStateObject['filter'] = this.remapFilters(results.refiners, currentFilterParams, "");
                }
            }

            setStateObject['isSearchingWithDeactivatedFilters'] = false;
            setStateObject['query'] = query;
            if (!isRerun) {
                setStateObject['querySuggestion'] = undefined;
            }
            setStateObject['currentPageNumber'] = _pageNumber;
            this.setState(setStateObject);
        }
    }

    private findNumberOfPages() {
        if (!this.state.results || !this.state.results.totalResults) {
            return 1;
        }
        return Math.ceil(this.findNumberOfResults() / this.resultPerPage);
    }

    private findNumberOfResults() {
        if (!this.state.results) {
            return 0;
        }
        return this.state.results.totalResults;
    }

    private async onFilterChanged(refinerName: string, refinerIndex: number) {
        let stateFilter = this.state.filter;
        if (!stateFilter) {
            return;
        }

        // Clear filtervalues=all from URL when user interacts with filters
        if (getUrlParameter(this.refinementFiltersShowAllValuesUrlParamName) === "all") {
            setUrlParameter(window.location.href, this.refinementFiltersShowAllValuesUrlParamName, '');
        }

        // Deep copy to ensure React detects changes
        let currentFilter: IRefiners[] = JSON.parse(JSON.stringify(stateFilter));
        let previousFilters = this.state.previousFilters;
        let currentFilterSelection = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries[refinerIndex];
        // Toggle based only on actual checked state. Ignore fakeChecked for interaction semantics.
        let newCheckedValue = !currentFilterSelection.checked;

        // Special case: If parent has fakeChecked (children are selected) and user clicks it, uncheck and hide all children
        if (currentFilterSelection.level === 0 && currentFilterSelection.fakeChecked && !currentFilterSelection.checked) {
            const childrenOfParent = currentFilter
                .filter(filter => filter.Name === refinerName)[0]
                .Entries.filter(fil => fil.parent === currentFilterSelection.RefinementName);
            
            // Remove all children from URL param
            let urlParam = getUrlParameter(refinerName) || '';
            childrenOfParent.forEach(child => {
                child.checked = false;
                child.hidden = true;
                // Remove child from URL
                urlParam = urlParam
                    .split(';')
                    .filter(val => val !== child.RefinementValue && val !== decodeURIComponent(child.RefinementValue))
                    .join(';');
            });
            setUrlParameter(window.location.href, refinerName, urlParam);
            
            currentFilterSelection.fakeChecked = false;
            currentFilterSelection.checked = false;
            newCheckedValue = false;
        } else {
            currentFilterSelection.checked = newCheckedValue;
        }

        // If clicking a parent and checking it, uncheck all its children
        if (currentFilterSelection.level === 0 && newCheckedValue) {
            const childrenOfParent = currentFilter
                .filter(filter => filter.Name === refinerName)[0]
                .Entries.filter(fil => fil.parent === currentFilterSelection.RefinementName);
            childrenOfParent.forEach(child => {
                child.checked = false;
            });
        }

        // Handle parent-child relationship
        if (currentFilterSelection.parent !== undefined && !newCheckedValue) {
            // Unchecking a child - check if we need to check the parent
            const parent = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.RefinementName === currentFilterSelection.parent)[0];
            const otherChildren = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.parent === parent.RefinementName && fil.checked === true);
            
            if (otherChildren.length === 0 && parent) {
                // No other children are checked, so check the parent
                parent.checked = true;
                parent.fakeChecked = false;
            }
        }
        
        // Handle checking a child - uncheck parent but keep it visually checked
        if (currentFilterSelection.parent !== undefined && newCheckedValue) {
            const parent = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.RefinementName === currentFilterSelection.parent)[0];
            if (parent) {
                parent.checked = false;
                parent.fakeChecked = true;
            }
        }

        let currentFilterUrlParam = getUrlParameter(refinerName);
        let newFilterParamValue = `${currentFilterSelection.RefinementValue}`;
        let newFilterUrlParam = '';
        if (currentFilterSelection.checked) {
            if (currentFilterUrlParam) {
                newFilterUrlParam = `${currentFilterUrlParam};${newFilterParamValue}`;
            } else {
                newFilterUrlParam = newFilterParamValue;
            }
        } else {
            if (currentFilterUrlParam) {
                newFilterUrlParam = currentFilterUrlParam
                    .split(';')
                    .filter(val => val !== newFilterParamValue)
                    .join(';');
            }
        }

        // Handle URL for parent/child relationships
        if (currentFilterSelection.level === 0 && newCheckedValue) {
            // Checking parent - remove all children from URL
            const childrenOfParent = currentFilter
                .filter(filter => filter.Name === refinerName)[0]
                .Entries.filter(fil => fil.parent === currentFilterSelection.RefinementName);
            childrenOfParent.forEach(child => {
                newFilterUrlParam = newFilterUrlParam
                    .split(';')
                    .filter(val => val !== child.RefinementValue && val !== decodeURIComponent(child.RefinementValue))
                    .join(';');
            });
        }

        if (currentFilterSelection.parent !== undefined && newCheckedValue) {
            // Checking a child - remove parent from URL
            const parent = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.RefinementName === currentFilterSelection.parent)[0];
            if (parent) {
                newFilterUrlParam = newFilterUrlParam
                    .split(';')
                    .filter(val => val !== parent.RefinementValue && val !== decodeURIComponent(parent.RefinementValue))
                    .join(';');
            }
        }

        if (currentFilterSelection.parent !== undefined && !newCheckedValue) {
            // Unchecking a child - check if parent should be added to URL
            const parent = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.RefinementName === currentFilterSelection.parent)[0];
            const otherChildren = currentFilter.filter(filter => filter.Name === refinerName)[0].Entries.filter(fil => fil.parent === parent?.RefinementName && fil.checked === true);
            
            if (otherChildren.length === 0 && parent && parent.checked) {
                // No other children are checked, add parent to URL
                if (newFilterUrlParam) {
                    newFilterUrlParam = `${newFilterUrlParam};${parent.RefinementValue}`;
                } else {
                    newFilterUrlParam = parent.RefinementValue;
                }
            }
        }

        setUrlParameter(window.location.href, refinerName, newFilterUrlParam);

        const queryString = this.state.query ? this.state.query : '';
        const newResults = await getResults(queryString, 1, currentFilter);

        // Check if there are still checked filters after this change
        const currentFilterParams = getFilterParametersFromUrl(this.refinementFilters);
        const hasCheckedFilters = currentFilterParams && currentFilterParams.length > 0;

        let nextFilter;
        if (hasCheckedFilters) {
            nextFilter = await this.buildFiltersDisjunctive(newResults, currentFilterParams, queryString, 1);
        } else {
            // No filters checked - use results directly
            nextFilter = this.remapFilters(newResults.refiners, currentFilterParams, refinerName);
        }

        let newPreviousFiltersToSave;
        if (!newCheckedValue) {
            if (previousFilters) {
                previousFilters = previousFilters.filter(filter => filter.Name !== refinerName);
                previousFilters.filter(filter => filter.Name !== refinerName).forEach(prevFilter => {
                    try {
                        nextFilter.filter(NF => (NF.Name === prevFilter.Name) !== null)[0].Entries = prevFilter.Entries;
                    } catch {
                        // Could not set nextFilter.filter
                    }
                });
                newPreviousFiltersToSave = previousFilters;
            }
        }

        let currentFilterSelectedNode = currentFilter.filter(val => val.Name === refinerName)[0];
        // Only use ensureSelectedFilterValues when checking a filter (to preserve the selected entry).
        // When unchecking, use nextFilter directly so that 0-count synthetic entries disappear.
        let finalFilter = newCheckedValue
            ? ensureSelectedFilterValues(nextFilter, currentFilterSelectedNode, refinerName)
            : nextFilter;
        
        this.setState({
            results: newResults,
            filter: finalFilter,
            currentPageNumber: 1,
            query: queryString,
            querySuggestion: undefined,
            previousFilters: newPreviousFiltersToSave
        });
    }

    private async emptyFilters() {
        let refiners = this.state.filter;
        if (refiners === undefined) {
            return;
        }

        const filterParams = [...this.refinementFilters, ...[this.refinementFiltersShowAllValuesUrlParamName]];
        removeAllFilterParams(window.location.href, filterParams);

        //Run the query without filters
        const query = this.state.query ? this.state.query : '*';

        this.runQuery(query, false, 1, []);
    }

    private async onAllFilterClicked(refinerName: string) {
        let stateRefiners = this.state.filter;

        if (!stateRefiners) return;

        let allFilterClickedRefiner = stateRefiners.filter(refiner => refiner.Name === refinerName)[0];
        if (allFilterClickedRefiner !== undefined) {
            const somethingIsChecked = allFilterClickedRefiner.Entries.filter(entry => entry.checked === true).length > 0;
            if (somethingIsChecked) {
                allFilterClickedRefiner.Entries.forEach(refinerValue => {
                    refinerValue.checked = false;
                });
                setUrlParameter(window.location.href, refinerName, '');
                const query = this.state.query ? this.state.query : '';
                let urlFilters = getFilterParametersFromUrl(this.refinementFilters);
                this.runQuery(query, false, 1, urlFilters);
            }
        }
    }
    private onRemoveFilter = (filterName: string, filterValue: string) => {
        // Remove filter value from URL
        const currentValue = getUrlParameter(filterName);
        if (currentValue) {
            const newValue = currentValue
                .split(';')
                .filter(v => decodeURIComponent(v) !== filterValue && v !== filterValue)
                .join(';');
            setUrlParameter(window.location.href, filterName, newValue);
        }

        // Run the query with updated filters from URL, preserving filter panel
        const queryString = this.state.query ? this.state.query : '*';
        const urlFiltersAfterRemoval = getFilterParametersFromUrl(this.refinementFilters);
        this.runQuery(queryString, false, 1, urlFiltersAfterRemoval, false, true);
    }
    private onSortChanged = (sortValue: string) => {
        // Re-run query with current filters preserved
        this.runQuery(
            this.state.query ? this.state.query : '', 
            false, 
            1, // Reset to first page
            this.state.filter, // Keep current filters
            false, // isInitialQuery
            true // preserveFilters - keep all filter options visible
        );
    }
    private onStatePopped() {
        const newStateQuery = getUrlParameter(this.queryParameter);
        const initialPageNumber = getUrlParameter('page');
        const safeInitialPageNumber = initialPageNumber ? +initialPageNumber : 1;
        const filterParameters = getFilterParametersFromUrl(this.refinementFilters);

        //Set up variables properly (like in the constructor), and run the setupjob
        this.setState(
            {
                newStateQuery: newStateQuery,
                initialQuery: newStateQuery,
                initialPageNumber: safeInitialPageNumber,
                initialFilters: filterParameters
            },
            () => {
                this.setupAndRunInitialQuery();
            }
        );
    }

    private _onWindowResize() {
        let currentDisplayFormat = getCurrentDisplayFormat();
        this.setState({ displayFormat: currentDisplayFormat });
    }

}
